.track {
  position: fixed;
  z-index: var(--z-progress);
  top: 50%;
  right: max(1.25rem, calc((100vw - var(--container-max)) / 2 + 1.25rem));
  width: 1px;
  height: 7.5rem;
  overflow: hidden;
  background: rgb(255 255 255 / 14%);
  transform: translateY(-50%);
}

.progress {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--color-primary);
  transform: scaleY(var(--page-progress, 0));
  transform-origin: top;
  will-change: transform;
}

@media (max-width: 63.9375rem) {
  .track {
    display: none;
  }
}
